module.exports = __webpack_public_path__ + "static/img/hedear-isbandyti.cb849b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hedear-isbandyti.png
// module id = IFD/
// module chunks = 9